
import { Component, Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { EpgDialogComponent, EpgDialogData } from './epg-dialog.component';

@Injectable()
export class EpgDialogService {

  constructor(private modalService: MatDialog) { }

  public confirm(
    title: string,
    _message: string,
    btnOkText: string = 'OK',
    btnCancelText: string | null = null,
    btnOkHidden: boolean = false,
    dialogSize: 'sm'| 'md' |'lg' = 'sm',
    btnOkColor?: 'primary' | 'accent' | 'warn'): MatDialogRef<EpgDialogComponent> {
    const lines = _message
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    const message = lines.reduce((parts: string[], line: string) => {
      // Split only on likely sentence boundaries (punctuation + space + uppercase).
      // This keeps file names like `quote-doc.pdf` intact.
      let start = 0;
      for (let i = 0; i < line.length - 2; i++) {
        const current = line.charAt(i);
        const next = line.charAt(i + 1);
        const nextNext = line.charAt(i + 2);
        const isSentenceBoundary = (current === '.' || current === '!' || current === '?')
          && next === ' '
          && nextNext >= 'A'
          && nextNext <= 'Z';
        if (isSentenceBoundary) {
          parts.push(line.slice(start, i + 1).trim());
          start = i + 2;
        }
      }
      const tail = line.slice(start).trim();
      if (tail.length > 0) {
        parts.push(tail);
      }
      return parts;
    }, []);

    const dialogData: EpgDialogData = {
      title,
      message,
      btnOkText,
      btnCancelText,
      btnOkHidden,
      dialogSize,
      btnOkColor
    };

    const modalRef = this.modalService.open(EpgDialogComponent, {
        hasBackdrop: true,
        disableClose: true,
      panelClass: ['epg-dialog', `epg-dialog-${dialogSize}`],
      data: dialogData
    });

    return modalRef;
  }

  public open(component: Type<Component>) {
    const modalRef = this.modalService.open(component, {
        hasBackdrop: true,
        disableClose: true,
        data: {}
    });

    return modalRef;
  }

}
